import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, Bell, Eye, Moon, Globe, Volume2, Vibrate, Mail } from 'lucide-react';
interface SettingsModalProps {
  onClose: () => void;
}
export function SettingsModal({
  onClose
}: SettingsModalProps) {
  const [notifications, setNotifications] = useState(true);
  const [emailNotifications, setEmailNotifications] = useState(false);
  const [sounds, setSounds] = useState(true);
  const [vibration, setVibration] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [showOnlineStatus, setShowOnlineStatus] = useState(true);
  const Toggle = ({
    enabled,
    onChange
  }: {
    enabled: boolean;
    onChange: (val: boolean) => void;
  }) => <button onClick={() => onChange(!enabled)} className={`w-12 h-7 rounded-full relative transition-colors ${enabled ? 'bg-gradient-to-r from-orange-500 to-rose-500' : 'bg-zinc-200'}`} data-id="element-495">
      <motion.div animate={{
      x: enabled ? 22 : 2
    }} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30
    }} className="absolute top-1 w-5 h-5 bg-white rounded-full shadow-sm" data-id="element-496" />
    </button>;
  const settingsGroups = [{
    title: 'Notifications',
    items: [{
      icon: Bell,
      label: 'Push Notifications',
      description: 'Get notified about new matches and messages',
      enabled: notifications,
      onChange: setNotifications
    }, {
      icon: Mail,
      label: 'Email Notifications',
      description: 'Receive updates via email',
      enabled: emailNotifications,
      onChange: setEmailNotifications
    }, {
      icon: Volume2,
      label: 'Sounds',
      description: 'Play sounds for notifications',
      enabled: sounds,
      onChange: setSounds
    }, {
      icon: Vibrate,
      label: 'Vibration',
      description: 'Vibrate on notifications',
      enabled: vibration,
      onChange: setVibration
    }]
  }, {
    title: 'Appearance',
    items: [{
      icon: Moon,
      label: 'Dark Mode',
      description: 'Switch to dark theme',
      enabled: darkMode,
      onChange: setDarkMode
    }]
  }, {
    title: 'Privacy',
    items: [{
      icon: Eye,
      label: 'Show Online Status',
      description: "Let others see when you're active",
      enabled: showOnlineStatus,
      onChange: setShowOnlineStatus
    }]
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="absolute inset-0 z-50 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-497">
      <motion.div initial={{
      x: '100%'
    }} animate={{
      x: 0
    }} exit={{
      x: '100%'
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="absolute right-0 top-0 bottom-0 w-full bg-white overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-498">
        {/* Header */}
        <div className="sticky top-0 bg-white/80 backdrop-blur-md border-b border-zinc-100 px-4 py-4 flex items-center gap-4 z-10" data-id="element-499">
          <button onClick={onClose} className="p-2 hover:bg-zinc-100 rounded-full transition-colors" data-id="element-500">
            <X size={24} className="text-zinc-600" data-id="element-501" />
          </button>
          <h1 className="text-xl font-bold text-zinc-900" data-id="element-502">Settings</h1>
        </div>

        {/* Settings Groups */}
        <div className="p-4 space-y-6" data-id="element-503">
          {settingsGroups.map((group, groupIndex) => <div key={groupIndex} data-id="element-504">
              <h2 className="text-xs font-bold text-zinc-400 uppercase tracking-wider mb-3 px-1" data-id="element-505">
                {group.title}
              </h2>
              <div className="bg-zinc-50 rounded-2xl overflow-hidden" data-id="element-506">
                {group.items.map((item, itemIndex) => <div key={itemIndex} className={`flex items-center justify-between p-4 ${itemIndex !== group.items.length - 1 ? 'border-b border-zinc-100' : ''}`} data-id="element-507">
                    <div className="flex items-center gap-3 flex-1" data-id="element-508">
                      <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-509">
                        <item.icon size={20} className="text-zinc-500" data-id="element-510" />
                      </div>
                      <div className="flex-1" data-id="element-511">
                        <p className="font-medium text-zinc-900" data-id="element-512">
                          {item.label}
                        </p>
                        <p className="text-xs text-zinc-500" data-id="element-513">
                          {item.description}
                        </p>
                      </div>
                    </div>
                    <Toggle enabled={item.enabled} onChange={item.onChange} data-id="element-514" />
                  </div>)}
              </div>
            </div>)}

          {/* Language */}
          <div data-id="element-515">
            <h2 className="text-xs font-bold text-zinc-400 uppercase tracking-wider mb-3 px-1" data-id="element-516">
              Language
            </h2>
            <button className="w-full bg-zinc-50 rounded-2xl p-4 flex items-center justify-between" data-id="element-517">
              <div className="flex items-center gap-3" data-id="element-518">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-519">
                  <Globe size={20} className="text-zinc-500" data-id="element-520" />
                </div>
                <span className="font-medium text-zinc-900" data-id="element-521">Language</span>
              </div>
              <span className="text-zinc-500" data-id="element-522">English</span>
            </button>
          </div>
        </div>

        {/* Save Button */}
        <div className="p-4 pt-0" data-id="element-523">
          <button onClick={onClose} className="w-full py-4 bg-gradient-to-r from-orange-500 to-rose-500 text-white rounded-2xl font-bold text-lg shadow-lg" data-id="element-524">
            Save Settings
          </button>
        </div>
      </motion.div>
    </motion.div>;
}